/* eslint-disable no-bitwise */
function now() {
	// timestamp (in secs!)
	return ~~(new Date() / 1000);
}
export default { now };
